/*
 * Public API Surface of nfrp-mas-retail-private-angular
 */

// export * from './foo/foo-module.module';
export * from './nfrp-mas-retail/nfrp-mas-retail-private-angular.module';
